import { Button, EventTouch, Node, _decorator } from 'cc';
import GameDependency from '../../../../System/GameDependency';
import Gesture from '../../../Utils/Gesture';

const { ccclass, property } = _decorator;

@ccclass('ButtonEventEffect')
export default class ButtonEventEffect extends GameDependency {
    @property(Button)
    private _button: Button = null;

    @property
    private readonly useCapture = false;

    @property(Button)
    protected get button(): Button {
        return this._button ?? this.getComponent(Button);
    }
    protected set button(value: Button) {
        if (this._button === value) {
            return;
        }
        this._button = value;
    }

    protected onLoad(): void {
        this.button.node.on(
            Node.EventType.TOUCH_START,
            () => {
                if (this.button.interactable && this.button.enabledInHierarchy) {
                    this.onButtonTouchStart();
                }
            },
            this,
            this.useCapture,
        );
        this.button.node.on(
            Node.EventType.TOUCH_END,
            () => {
                if (this.button.interactable && this.button.enabledInHierarchy) {
                    this.onButtonTouchEnd();
                }
            },
            this,
            this.useCapture,
        );
        this.button.node.on(
            Node.EventType.TOUCH_CANCEL,
            () => {
                if (this.button.interactable && this.button.enabledInHierarchy) {
                    this.onButtonTouchCancel();
                }
            },
            this,
            this.useCapture,
        );
        this.button.node.on(
            Node.EventType.TOUCH_MOVE,
            (event: EventTouch) => {
                if (this.button.interactable && this.button.enabledInHierarchy) {
                    this.onButtonTouchMove();
                    if (Gesture.Click.insideTarget(event) && !Gesture.Click.insideTarget(event, null, event.touch.getUIPreviousLocation())) {
                        this.onButtonTouchMoveIn();
                    } else if (!Gesture.Click.insideTarget(event) && Gesture.Click.insideTarget(event, null, event.touch.getUIPreviousLocation())) {
                        this.onButtonTouchMoveOut();
                    }
                }
            },
            this,
            this.useCapture,
        );
        this.button.node.on(
            Button.EventType.STATE_RESET,
            () => {
                this.onButtonStateReset();
            },
            this,
            this.useCapture,
        );
    }

    protected onButtonTouchStart(): void {}
    protected onButtonTouchEnd(): void {}
    protected onButtonTouchCancel(): void {}
    protected onButtonTouchMove(): void {}
    protected onButtonTouchMoveIn(): void {}
    protected onButtonTouchMoveOut(): void {}
    protected onButtonStateReset(): void {}
}
